import { createSelector } from '@reduxjs/toolkit';

// Base selectors
const selectPartnerDetailsState = (state: any) => state.partner_details;

// Memoized selectors
export const selectPartnerTypes = createSelector(
  [selectPartnerDetailsState],
  (partnerDetails) => partnerDetails.partnerTypes
);

export const selectRevenueStream = createSelector(
  [selectPartnerDetailsState],
  (partnerDetails) => partnerDetails.revenueStream
);

export const selectPartnerVertical = createSelector(
  [selectPartnerDetailsState],
  (partnerDetails) => partnerDetails.partnerVertical
);

export const selectPartnerTier = createSelector(
  [selectPartnerDetailsState],
  (partnerDetails) => partnerDetails.partnerTier
);

export const selectPartnerDetails = createSelector(
  [selectPartnerDetailsState],
  (partnerDetails) => partnerDetails.partnerDetails
);

export const selectAllPartners = createSelector(
  [selectPartnerDetailsState],
  (partnerDetails) => partnerDetails.allPartners
);

export const selectFilteredPartners = createSelector(
  [selectPartnerDetailsState],
  (partnerDetails) => partnerDetails.filteredPartners
);

export const selectPartnerChildren = createSelector(
  [selectPartnerDetailsState],
  (partnerDetails) => partnerDetails.partnerChildren
);

// Status selectors
export const selectPartnerDetailsLoading = createSelector(
  [selectPartnerDetailsState],
  (partnerDetails) => partnerDetails.status.partnerDetailsLoading
);

export const selectAddPartnerLoading = createSelector(
  [selectPartnerDetailsState],
  (partnerDetails) => partnerDetails.status.addPartnerLoading
);

export const selectUpdatePartnerLoading = createSelector(
  [selectPartnerDetailsState],
  (partnerDetails) => partnerDetails.status.updatePartnerLoading
);

export const selectAllPartnersLoading = createSelector(
  [selectPartnerDetailsState],
  (partnerDetails) => partnerDetails.status.allPartnersLoading
);

export const selectFilteredPartnersLoading = createSelector(
  [selectPartnerDetailsState],
  (partnerDetails) => partnerDetails.status.filteredPartnersLoading
);

export const selectPartnerChildrenLoading = createSelector(
  [selectPartnerDetailsState],
  (partnerDetails) => partnerDetails.status.partnerChildrenLoading
);

export const selectLinkPartnerLoading = createSelector(
  [selectPartnerDetailsState],
  (partnerDetails) => partnerDetails.status.linkPartnerLoading
);

export const selectTogglePartnerEnableLoading = createSelector(
  [selectPartnerDetailsState],
  (partnerDetails) => partnerDetails.status.togglePartnerEnableLoading
);

export const selectDeletePartnerLoading = createSelector(
  [selectPartnerDetailsState],
  (partnerDetails) => partnerDetails.status.deletePartnerLoading
);

// Combined selectors for form data
export const selectFormLookupData = createSelector(
  [selectPartnerTypes, selectRevenueStream, selectPartnerVertical, selectPartnerTier],
  (partnerTypes, revenueStream, partnerVertical, partnerTier) => ({
    partnerTypes,
    revenueStream,
    partnerVertical,
    partnerTier
  })
);

export const selectPartnerStatus = createSelector(
  [selectPartnerDetailsState],
  (partnerDetails) => partnerDetails.status
);
